import "@/App.css";
import Nav from "@/components/Nav";
import ScrollProgress from "@/components/ScrollProgress";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Message from "@/components/Message";
import JointHealth from "@/components/JointHealth";
import REcorner from "@/components/FitnessCorner";
import Career from "@/components/Career";
import Blog from "@/components/Blog";
import Press from "@/components/Press";
import BlogSchema from "@/components/BlogSchema";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { useReveal } from "@/hooks/useReveal";
import { useEffect, useState } from "react";
import { BLOG_POSTS } from "@/data/blogPosts";
import { slugFromPath } from "@/lib/seo";

// Direct visits to /blog/<slug> render the article first; the rest of the
// page mounts on first interaction (or shortly after) to keep the article fast.
const isArticleEntry = () => {
  if (typeof window === "undefined") return false;
  const slug = slugFromPath(window.location.pathname);
  return !!slug && BLOG_POSTS.some((p) => p.id === slug);
};

function App() {
  const [showAll, setShowAll] = useState(() => !isArticleEntry());
  const rootRef = useReveal(showAll);

  useEffect(() => {
    if (showAll) return undefined;
    const go = () => setShowAll(true);
    const events = ["pointerdown", "keydown", "touchstart", "wheel"];
    events.forEach((e) => window.addEventListener(e, go, { once: true, passive: true }));
    const t = setTimeout(go, 6000);
    return () => {
      clearTimeout(t);
      events.forEach((e) => window.removeEventListener(e, go));
    };
  }, [showAll]);

  return (
    <div className="App" ref={rootRef} data-testid="app-root">
      <BlogSchema />
      <ScrollProgress />
      <Nav />
      <main>
        {showAll && (
          <>
            <Hero />
            <Marquee />
            <About />
            <Message />
            <JointHealth />
            <REcorner />
            <Career />
          </>
        )}
        <Blog sectionHidden={!showAll} onDeepLinkClose={() => setShowAll(true)} />
        {showAll && (
          <>
            <Press />
            <FAQ />
            <Contact />
          </>
        )}
      </main>
      {showAll && <Footer />}
    </div>
  );
}

export default App;
